var $ = (global.jQuery = require('jquery'));
var _ = require('underscore');
var Marionette = require('backbone.marionette');
var PhotoSelectorTpl = require('./templates/photo-selector.html');
var Tooltips = require('app/common/behaviors/tooltips');
var Popover = require('app/common/behaviors/popover');
var Template = require('app/utils/template');

var PhotoSelector = Marionette.ItemView.extend({
    template: false,
    behaviors: {
        Tooltips: {
            behaviorClass: Tooltips,
        },
        Popover: {
            behaviorClass: Popover,
        },
    },
    photoSelectorTemplate: Template(PhotoSelectorTpl),
    ui: {
        input: 'input:first',
        widget: '[data-ui="widget"]',
        selectedPhoto: '[data-ui="selectedPhoto"]',
        dropdown: '[data-ui="dropdown"]',
        photoOption: '[data-ui="photoOption"]',
    },
    events: {
        'change @ui.input': 'updatePhotos',
        'click @ui.selectedPhoto': 'openDropdown',
        'click @ui.dropdown': function(e) {
            e.stopPropagation();
        },
        'click @ui.photoOption': 'selectPhoto',
    },
    initialize: function() {
        this.data = this.getOption('data').call(this.getOption('form'));
        this.photoCount = this.getOption('photoCount').call(this.getOption('form'));
        this.photosRequired = this.getOption('photosRequired').call(this.getOption('form'));
        this.bindUIElements();
    },
    onBeforeRender: function() {
        this.ui.input.hide();
        this.renderWidget();
    },
    onDestroy: function() {
        this._detachClickHandler();
    },
    onDeserialize: function() {
        this.updatePhotos();
    },
    closeDropdown: function() {
        this._detachClickHandler();
        this.ui.selectedPhoto.eq(this.selectedIdx).removeClass('selected');
        this.ui.dropdown.addClass('hidden');
        this.$('[data-toggle="tooltip"]').tooltip('hide');
        delete this.selectedIdx;
    },
    openDropdown: function(e) {
        e.stopPropagation();
        var $photo = $(e.currentTarget);
        var newIdx = +$photo.data('idx');

        if (this.selectedIdx === newIdx) {
            this.closeDropdown();
        } else {
            this.ui.selectedPhoto.removeClass('selected');
            $photo.addClass('selected');
            this.selectedIdx = newIdx;
            this._attachClickHandler();
            this.ui.dropdown.removeClass('hidden');
            this.updateDropdown();
        }
    },
    renderWidget: function() {
        var html = this.photoSelectorTemplate({
            data: this.data,
            underscore: _,
            photoCount: this.photoCount,
            photosRequired: this.photosRequired,
        });
        this.ui.widget.addClass('photo-selector');
        this.ui.widget.html(html);
        this.bindUIElements();
    },
    updateDropdown: function() {
        this.ui.photoOption.removeClass('selected primary-selected secondary-selected');

        _.each(
            this._getVals(),
            function(id, idx) {
                if (idx == this.selectedIdx) {
                    this._getDropdownPhoto(id).addClass('primary-selected selected');
                } else {
                    this._getDropdownPhoto(id).addClass('secondary-selected selected');
                }
            },
            this
        );
    },
    selectPhoto: function(e) {
        e.stopPropagation();
        var $photo = $(e.currentTarget);
        if ($photo.hasClass('disabled')) {
            return;
        }
        this._setVals(this.selectedIdx, $photo.data('id'));
        this.closeDropdown();
    },
    updatePhotos: function() {
        _.each(
            this._getVals(),
            function(val, i) {
                var url = _.findWhere(this.data, { id: val }).small;
                this.ui.selectedPhoto
                    .eq(i)
                    .find('img')
                    .attr('src', url);
            },
            this
        );
    },
    _attachClickHandler: function() {
        if (this._handler) {
            return;
        }

        this._handler = function() {
            this.closeDropdown();
        }.bind(this);

        $('body').click(this._handler);
    },
    _detachClickHandler: function() {
        if (this._handler) {
            $('body').off('click', this._handler);
            delete this._handler;
        }
    },
    _getDropdownPhoto: function(id) {
        return this.ui.photoOption.filter('[data-id="' + id + '"]');
    },
    _setVals: function(newIdx, val) {
        var vals = this._getVals();
        var currentIdx = vals.indexOf(val);
        if (newIdx == currentIdx) {
            // value is already in that place so do nothing
            return;
        } else if (currentIdx >= 0) {
            // value is somewhere else in array, so swap 'em!
            vals[currentIdx] = vals[newIdx];
            vals[newIdx] = val;
        } else {
            // value doesnt exist yet, so put it in
            vals[newIdx] = val;
        }
        this.ui.input.val(JSON.stringify(vals)).change();
    },
    _getVals: function() {
        return JSON.parse(this.ui.input.val());
    },
});

module.exports = PhotoSelector;
